module.exports = __webpack_public_path__ + "img/tie-hair.be629936.svg";